import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const orderExpiryCountdownDisplayTextValidator = Validator.object({
    countdownLabelFormat: nonEmptyStringValidator
});
export const defaultOrderExpiryCountdownDisplayText = {
    countdownLabelFormat: 'Time remaining: ${minutes}:${seconds}'
};
